var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { GraphConfig } from '../../shared/gallery/graph-config';
import * as _ from 'lodash';
import { AsyncSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConsts } from '../AppConsts';
import { GraphUtils } from '../../main/view-data/shared/graph/graph-utils';
// @dynamic
var GraphService = /** @class */ (function () {
    function GraphService(http, galleryServiceProxy) {
        this.http = http;
        this.galleryServiceProxy = galleryServiceProxy;
        this.galleryJsonFileName = 'index.json';
    }
    GraphService_1 = GraphService;
    Object.defineProperty(GraphService, "baseUrl", {
        get: function () {
            return AppConsts.remoteServiceBaseUrl + '/gallery';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphService, "systemUrl", {
        get: function () {
            return AppConsts.remoteServiceBaseUrl + '/systemgallery';
        },
        enumerable: true,
        configurable: true
    });
    GraphService.prototype.getGraphConfigs = function (type) {
        return this.galleryServiceProxy.getGalleryConfig(type).pipe(map(function (galleryConfig) {
            var graphConfigList = new Array();
            _.each(galleryConfig, function (config) {
                var graphConfig = new GraphConfig();
                graphConfig.id = config.id;
                graphConfig.name = config.name;
                graphConfig.thumbUrl = [GraphService_1.baseUrl, config.id, config.thumbUrl].join('/');
                graphConfig.stateCount = config.stateCount;
                graphConfigList.push(graphConfig);
            });
            return graphConfigList;
        }));
    };
    GraphService.prototype.getGraphStateUrl = function (graphId, stateId) {
        return this.getGraphConfig(graphId).pipe(map(function (config) {
            var stateUrl;
            if (config.states && config.states.length > 0) {
                var state = _.find(config.states, function (s) { return s.id === stateId; });
                if (null != state && null != state.url) {
                    stateUrl = [graphId, state.url].join('/');
                }
            }
            return stateUrl;
        }));
    };
    GraphService.prototype.getSysSvgContent = function (stateUrl) {
        var ob = this.deferredAsObservable($.get(stateUrl));
        return ob.map(function (data) {
            return data.documentElement.outerHTML;
        });
    };
    GraphService.prototype.getSvgContent = function (graphId, stateUrl) {
        var ob = this.deferredAsObservable($.get(AppConsts.remoteServiceBaseUrl + stateUrl));
        return ob.map(function (data) {
            return data.documentElement.outerHTML;
        });
    };
    GraphService.prototype.getGraphConfig = function (graphId) {
        return this.http.get(this.getGraphConfigUrl(graphId)).pipe(map(function (config) {
            return config;
        }));
    };
    GraphService.prototype.getAbsoluteStateUrl = function (graphId, stateUrl) {
        return [GraphService_1.baseUrl, graphId, stateUrl].join('/');
    };
    GraphService.prototype.getCustomStyleGraphUrl = function (graphSetting) {
        return GraphUtils.getCustomStyleGraphUrl(graphSetting);
    };
    GraphService.prototype.getCustomStyle = function (graphSetting, stateIndex) {
        return GraphUtils.getCustomStyle(graphSetting, stateIndex);
    };
    GraphService.prototype.getGraphConfigUrl = function (graphId) {
        return [GraphService_1.baseUrl, graphId, this.galleryJsonFileName].join('/');
    };
    GraphService.prototype.deferredAsObservable = function (deferred) {
        // Create a new observable.  The AsyncSubject class is a type of Cold observable,
        // which means that when a user subscribes to the observable, they get items that
        // occurred before the subscription.
        var observable = new AsyncSubject();
        // When the Deferred is complete, push an item through the Observable
        deferred.done(function () {
            // Get the arguments as an array
            var args = Array.prototype.slice.call(arguments);
            // Call the observable OnNext with the same parameters
            observable.next.apply(observable, args);
            // Complete the Observable to indicate that there are no more items.
            observable.complete();
        });
        // If the Deferred errors, push an error through the Observable
        deferred.fail(function () {
            // Get the arguments as an array
            var args = Array.prototype.slice.call(arguments);
            // Call the observable OnError with the args array
            observable.error.apply(observable, args);
            observable.complete();
        });
        return observable;
    };
    var GraphService_1;
    GraphService = GraphService_1 = __decorate([
        Injectable()
    ], GraphService);
    return GraphService;
}());
export { GraphService };
